import {eventBus} from "../../../event-bus";
import React, {useEffect, useRef, useState} from "react";
import {Pagination, Box, CircularProgress, MenuItem} from "@mui/material";
import {useTranslation} from "react-i18next";
import i18n from "../../../i18n/i18n";
import axiosInstance from "../../../config/axios-config";
import TableContainerComp from "../../../components/table-container-comp";
import {TabPanel} from "../../../components/tab-panel-comp";
import {ItemsSelect, SearchField, SearchFilterContainer} from "../../../components/common/search-filter-container";
import {PaginationContainer} from "../../../components/common/page-container";
import ProductDetailsDialog from "../../../dialog/product-details-dialog";
import GlowingMessage from "../../../errors/glowing-message";

const TabAllProducts = ({tabValue, tenantId, tenantType}) => {

    const [distributors, setDistributors] = useState([])
    const [page, setPage] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const [category, setCategory] = useState("");
    const [detailsDialogOpen, setDetailsDialogOpen] = useState(false)
    const [selectedProductForDetails, setSelectedProductForDetails] = useState(null)
    const [manufacturer, setManufacturer] = useState("");
    const [debounceTimeout, setDebounceTimeout] = useState(null);
    const {t} = useTranslation();

    const [rows, setProducts] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const isFirstRender = useRef(true);

    const fetchProducts = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get(`/api/v1/product_tenants/pharmacy/all/${tenantId}`, {
                params: {
                    searchTerm: searchQuery.length >= 3 ? searchQuery : null,
                    manufacturer: manufacturer === t("Manufacturer") ? null : manufacturer,
                    category: category.toUpperCase(),
                    page: page,
                    size: 10
                },
                headers: {
                    "Language-Context": i18n.language.toUpperCase() || "EN",
                }
            });
            const {content, totalPages} = response.data;
            setProducts(content);
            setTotalPages(totalPages);
        } catch (error) {
            setMessage(error.response?.data?.message || "Failed to get all products.");
            console.error("Error fetching products:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (rows && rows.length > 0) {
            const uniqueDistributors = [...new Set(rows.map((product) => product.productManufacturer))].filter(Boolean)
            setDistributors(uniqueDistributors)
        }
    }, [rows])


    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (debounceTimeout) clearTimeout(debounceTimeout);

        setDebounceTimeout(setTimeout(() => {
            setPage(0)
            fetchProducts().then(r => console.log(r));
        }, 500));

        return () => clearTimeout(debounceTimeout);
    }, [searchQuery, category, manufacturer]);

    useEffect(() => {
        fetchProducts().then(r => console.log(r));
    }, [page, t]);


    const handlePageChange = (_, newPage) => {
        setPage(newPage - 1);
    };

    useEffect(() => {
        const handleRefresh = () => {
            fetchProducts().then(r => console.log(r))
        }
        eventBus.on("refreshProductsData", handleRefresh)
        return () => {
            eventBus.off("refreshProductsData", handleRefresh)
        }
    });

    const list_categories = ["MEDICINES", "MEDICAL_EQUIPMENT", "MEDICINAL_COSMETICS", "FOR_CHILDREN", "BABY_FOOD", "COSMETICS", "PSYCHOACTIVE", "CONTRACEPTIVES", "OTHER"]


    // // Example data
    // const rows = [
    //     {productCode: "001",category: "MEDICINES", manufacturer: "Egis", productPackage: "Box", productArticle: "AA", productCountry: "Germany", company: "Company A", product: "Product X", endDate: "2024-12-31", price: 500, discount: "10%", count: 5},
    //     {productCode: "001",category: "MEDICINES", manufacturer: "Egis", productPackage: "Box", productArticle: "AA", productCountry: "Germany", company: "Company B", product: "Product Y", endDate: "2024-11-30", price: 500, discount: "20%", count: 3},
    //     {productCode: "001",category: "MEDICINES", manufacturer: "Egis", productPackage: "Box", productArticle: "AA", productCountry: "Germany", company: "Company C", product: "Product Z", endDate: "2024-10-15", price: 500, discount: "30%", count: 7},
    //     {productCode: "001",category: "FOR_CHILDREN", manufacturer: "Egis", productPackage: "Box", productArticle: "AA", productCountry: "Germany", company: "Company A", product: "Product W", endDate: "2024-08-01", price: 200, discount: "5%", count: 2},
    //     {productCode: "001",category: "MEDICINES", manufacturer: "Egis", productPackage: "Box", productArticle: "AA", productCountry: "Germany", company: "Company D", product: "Product V", endDate: "2024-07-20", price: 200, discount: "15%", count: 6},
    //     {productCode: "001",category: "MEDICINES", manufacturer: "Egis", productPackage: "Box", productArticle: "AA", productCountry: "Germany", company: "Company D", product: "Product V", endDate: "2024-07-20", price: 200, discount: "15%", count: 6},
    //     {productCode: "001",category: "MEDICINES", manufacturer: "Egis", productPackage: "Box", productArticle: "AA", productCountry: "Germany", company: "Company D", product: "Product V", endDate: "2024-07-20", price: 200, discount: "15%", count: 6},
    //     {productCode: "001",category: "MEDICINES", manufacturer: "Egis", productPackage: "Box", productArticle: "AA", productCountry: "Germany", company: "Company D", product: "Product V", endDate: "2024-07-20", price: 200, discount: "15%", count: 6},
    //     {productCode: "001",category: "MEDICINES", manufacturer: "Egis", productPackage: "Box", productArticle: "AA", productCountry: "Germany", company: "Company D", product: "Product V", endDate: "2024-07-20", price: 200, discount: "15%", count: 6},
    //     {productCode: "001",category: "MEDICINES", manufacturer: "Egis", productPackage: "Box", productArticle: "AA", productCountry: "Germany", company: "Company D", product: "Product V", endDate: "2024-07-20", price: 200, discount: "15%", count: 6},
    //     ];

    const handleProductNameClick = (product) => {
        setSelectedProductForDetails(product)
        setDetailsDialogOpen(true)
    }

    const handleDetailsDialogClose = () => {
        fetchProducts(page, searchQuery, category, manufacturer)
            .then(r => console.log(r))
        setDetailsDialogOpen(false)
    }


    return (
        <>
            <GlowingMessage message={message} onClose={() => setMessage("")}/>
            <TabPanel value={tabValue} index={1} typePanel="distributor">
                <Box sx={{padding: 2}}>
                    <SearchFilterContainer>
                        <SearchField
                            placeholder={t("Search")}
                            variant="outlined"
                            size="small"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />

                        <ItemsSelect
                            size="small"
                            select
                            value={manufacturer || t("Manufacturer")}
                            onChange={(e) => setManufacturer(e.target.value)}
                            variant="outlined"
                            SelectProps={{
                                MenuProps: {
                                    disableScrollLock: true,
                                    disablePortal: true,
                                },
                            }}
                        >
                            <MenuItem value={t("Manufacturer")}>{t("Manufacturer")}</MenuItem>
                            {distributors.map((distributor) => (
                                <MenuItem key={distributor} value={distributor}>
                                    {distributor}
                                </MenuItem>
                            ))}
                        </ItemsSelect>

                        <ItemsSelect
                            size="small"
                            select
                            value={category || t("AllCategories")}
                            onChange={(e) => setCategory(e.target.value)}
                            variant="outlined"
                            SelectProps={{
                                MenuProps: {
                                    disableScrollLock: true,
                                    disablePortal: true,
                                },
                            }}
                        >
                            <MenuItem value={t("AllCategories")}>{t("AllCategories")}</MenuItem>
                            {list_categories.map((category) => (
                                <MenuItem key={category} value={category}>
                                    {t(category)}
                                </MenuItem>
                            ))}
                        </ItemsSelect>
                    </SearchFilterContainer>

                    {loading ? (
                        <Box display="flex" justifyContent="center" alignItems="center" height={300}>
                            <CircularProgress/>
                        </Box>
                    ) : (
                        <TableContainerComp
                            rows={rows}
                            isDistributor={false}
                            onProductNameClick={handleProductNameClick}
                        />
                    )}

                    <PaginationContainer>
                        <Pagination
                            count={totalPages}
                            page={page + 1}
                            onChange={handlePageChange}
                            color="primary"
                            variant="outlined"
                            shape="rounded"
                            siblingCount={1}
                        />
                    </PaginationContainer>
                    <ProductDetailsDialog
                        open={detailsDialogOpen}
                        onClose={handleDetailsDialogClose}
                        product={selectedProductForDetails}
                        tenantType={tenantType}
                    />
                </Box>
            </TabPanel>
        </>
    );
};

export default TabAllProducts;
